import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface StreetViewState {
  key: string;
}

const initialState: StreetViewState = {
  key: ''
};

const streetViewSlice = createSlice({
  name: 'streetView',
  initialState,
  reducers: {
    setStreetViewKey: (state, action: PayloadAction<string>) => {
      state.key = action.payload;
    }
  }
});

export const { setStreetViewKey } = streetViewSlice.actions;

export default streetViewSlice.reducer;
